<ng-container *ngIf="antwoordResultaat && antwoordResultaat.resultaat && antwoordResultaat.resultaat.van">
  <div data-hj-suppress>Van {{antwoordResultaat.resultaat.van | date:'d MMMM yyyy'}} t/m
    {{antwoordResultaat.resultaat.tot | date:'d MMMM yyyy'}}</div>
</ng-container>